import { createFileRoute, redirect } from "@tanstack/react-router";

/** Ruta legada — la home de plataforma es `/`. */
export const Route = createFileRoute("/marketing")({
  beforeLoad: () => {
    throw redirect({ to: "/", statusCode: 301 });
  },
});
